import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { Input, Label, Table } from "reactstrap";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";

const headers = () => ({ Authorization: `Bearer: ${localStorage.getItem("app_token")}` });
const fmtN = (v) => new Intl.NumberFormat("es-MX").format(v || 0);
const fmtM = (v) => new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN", maximumFractionDigits: 0 }).format(v || 0);

function SugeridoCompra() {
  const { user } = useContext(AuthContext);
  const URL_REPORTES = process.env.REACT_APP_URL_REPORTES;
  const [d, setD] = useState(null);
  const [temporada, setTemporada] = useState("");
  const [crecimiento, setCrecimiento] = useState(10);

  useEffect(() => {
    const q = new URLSearchParams({ crecimiento: crecimiento || 0, ...(temporada ? { temporada } : {}) });
    axios.get(`${URL_REPORTES}/sugerido?${q}`, { headers: headers() }).then((r) => setD(r.data)).catch(console.log);
  }, [URL_REPORTES, temporada, crecimiento]);

  if (!user.menu_oc) return <Header />;
  const filas = (d?.detalle || []).filter((f) => f.vendido > 0 || f.cajas > 0);

  return (
    <>
      <Header />
      <div className="card container col-12 rp">
        <div className="page-header">
          <div><h3 className="page-title">Sugerido de compra</h3><p className="page-subtitle">{d ? `Basado en lo vendido del ${d.ventana.desde} al ${d.ventana.hasta}` : "Calculando..."}</p></div>
        </div>
        <div className="rp-selects" style={{ maxWidth: 520 }}>
          <div>
            <Label>Temporada</Label>
            <Input bsSize="sm" type="select" value={d?.temporada || ""} onChange={(e) => setTemporada(e.target.value)}>
              {(d?.opciones || []).map((o) => <option key={o.id} value={o.id}>{o.nombre}</option>)}
            </Input>
          </div>
          <div>
            <Label>Crecimiento esperado %</Label>
            <Input bsSize="sm" type="number" min="0" value={crecimiento} onChange={(e) => setCrecimiento(e.target.value)} />
          </div>
        </div>
        {d && (
          <div className="rp-kpis">
            <div className="rp-kpi"><span>Cajas sugeridas</span><strong>{fmtN(d.totales.cajas)}</strong></div>
            <div className="rp-kpi"><span>Botellas</span><strong>{fmtN(d.totales.botellas)}</strong></div>
            <div className="rp-kpi"><span>Inversion estimada</span><strong>{fmtM(d.totales.importe)}</strong></div>
            <div className="rp-kpi"><span>Vinos a pedir</span><strong>{fmtN(d.totales.vinos)}</strong></div>
          </div>
        )}
        <Table size="sm" responsive>
          <thead><tr><th>Vino</th><th>Tipo</th><th className="text-right">Vendido</th><th className="text-right">Objetivo</th><th className="text-right">Existencia</th><th className="text-right">En camino</th><th className="text-right">Cajas a pedir</th><th className="text-right">Inversion</th></tr></thead>
          <tbody>
            {filas.map((f) => (
              <tr key={f.vino}>
                <td>{f.vino}</td><td>{f.tipo}</td><td className="text-right">{fmtN(f.vendido)}</td><td className="text-right">{fmtN(f.objetivo)}</td>
                <td className="text-right">{fmtN(f.existencia)}</td><td className="text-right">{fmtN(f.enCamino)}</td>
                <td className="text-right negrita">{fmtN(f.cajas)}</td><td className="text-right td-money">{fmtM(f.importe)}</td>
              </tr>
            ))}
            {filas.length === 0 && <tr><td colSpan={8} className="text-center">Sin ventas en la ventana de comparacion</td></tr>}
          </tbody>
        </Table>
      </div>
    </>
  );
}

export default SugeridoCompra;
